import { useTheme } from '@mui/material'
import { useIntl } from 'react-intl'
import { messages } from '@src/utils/messages'

type ProductFeaturesBadge = {
  color: string
  icon: string
  iconAlt: string
  id: string
  label: string
  textColor: string
  tooltipTitle: string
}

export const useProductFeaturesBadge = (attributes) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  const featuresBadges: ProductFeaturesBadge[] = [
    {
      id: 'greener alternative category.default',
      label: formatMessage(messages.GREENER_ALTERNATIVE_TITLE),
      icon: '/static/greener_alternative_product.svg',
      iconAlt: 'greener alternative',
      color: theme.palette.badge.highContrastGreen,
      textColor: theme.palette.common.white,
      tooltipTitle: formatMessage(messages.GREENER_ALTERNATIVE_PRODUCT),
    },
    {
      id: 'enhanced validation.default',
      label: formatMessage(messages.ENHANCED_VALIDATION_TITLE),
      icon: '/static/enhanced_validation.svg',
      iconAlt: 'enhanced validation',
      color: theme.palette.sensitive.pink,
      textColor: theme.palette.secondary.main,
      tooltipTitle: formatMessage(messages.ENHANCED_VALIDATION),
    },
  ]

  const attributesSet = new Set(
    attributes
      ?.map((a) => a.id?.toLowerCase().trim())
      .filter(Boolean) as string[]
  )

  return {
    productFeaturesBadges: (featuresBadges || []).filter((allowed) =>
      attributesSet.has(allowed.id.toLowerCase().trim())
    ),
  }
}
